import { createFileRoute } from "@tanstack/react-router";
import { ResidentNotesPage } from "@/components/app/portal/pages/resident-notes-page";

export const Route = createFileRoute("/family-portal/$residentId/notes")({
  head: () => ({ meta: [{ title: "Notes | People AI" }] }),
  component: FamilyNotes,
});

function FamilyNotes() {
  const { residentId } = Route.useParams();
  return <ResidentNotesPage kind="family" residentId={residentId} />;
}
